import React from "react";
import { Card, Divider, Typography } from "antd";
import GSMInward from "../../../components/GSuperMarket/GSMInwatd/GSMInward";
import "../../../styles/global-ui.css";

const GSMInwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Bin Inward
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Receive and process inward bins for garment supermarket
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <GSMInward userData={userData} />
      </Card>
    </div>
  );
};

export default GSMInwardPage;